<template>
  <div class="col-12">
    <Search
      :url="url"
      :allowFields="$lang.searchContactUs"
      :hiddenFields="hiddenFields"
      :title="$lang.login_problems_tickets"
      :remove_item="remove_item"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :dynamicButtons="buttons"
      :showLoading="true"
      :visibleAdd="false"
      ref="searchContactUs"
      :order_by="`created_at:desc`"
      :openNewTab="true"
      routeName="edit_contact_us"
      :changeColorRow="changeColorRow"
      :colorRows="true"
      :filterCatch="true"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";

export default {
  name: "contact-us-search",
  components: {
    Search,
  },
  data() {
    return {
      hiddenFields: ["mobile", "id"],
      url: this.$config.api_url + this.$config.resources.contact_us,
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        // {
        //   id: "2",
        //   name: "enable",
        // },
        //   {
        //     id: "3",
        //     name: "delete",
        //   }
      ],
    };
  },
  inject: ["contactUsRepository"],
  methods: {
    async remove_item(item) {
      try {
        const response = await this.contactUsRepository.delete(item.code);
        this.$this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    changeColorRow(rows) {
      return rows.map((row) => {
        const data = {
          ...row,
          _cellVariants: {
            delay_hour: "",
          },
        };
        const delayHour = Number(row.delay_hour);

        if (Number(row.acting_status.id) !== 1) {
          return data;
        }
        if (delayHour > 24 && delayHour <= 48) {
          data._cellVariants.delay_hour = "warning";
        }
        if (delayHour > 48) {
          data._cellVariants.delay_hour = "danger";
        }
        return data;
      });
    },
  },
};
</script>